import { render, staticRenderFns } from "./proxy.vue?vue&type=template&id=ccf7264e&scoped=true"
import script from "./proxy.vue?vue&type=script&lang=js"
export * from "./proxy.vue?vue&type=script&lang=js"
import style0 from "./proxy.vue?vue&type=style&index=0&id=ccf7264e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf7264e",
  null
  
)

export default component.exports